<form [formGroup]="identityForm" class="bv-vault-identity-details tw-mb-0">
  <div class="bv-vault-identity-details__group">
    <bit-form-field disableMargin>
      <bit-label>{{ "title" | i18n }}</bit-label>
      <bit-select formControlName="title">
        @for (title of identityTitleOptions; track title.value) {
          <bit-option [value]="title.value" [label]="title.name"></bit-option>
        }
      </bit-select>
    </bit-form-field>

    <div class="bv-vault-item-form-row bv-vault-item-form-row--3">
      <bit-form-field disableMargin>
        <bit-label>{{ "firstName" | i18n }}</bit-label>
        <input bitInput formControlName="firstName" />
      </bit-form-field>
      <bit-form-field disableMargin>
        <bit-label>{{ "middleName" | i18n }}</bit-label>
        <input bitInput formControlName="middleName" />
      </bit-form-field>
      <bit-form-field disableMargin>
        <bit-label>{{ "lastName" | i18n }}</bit-label>
        <input bitInput formControlName="lastName" />
      </bit-form-field>
    </div>
  </div>

  <div class="bv-vault-item-form-row">
    <bit-form-field disableMargin>
      <bit-label>{{ "username" | i18n }}</bit-label>
      <input bitInput formControlName="username" />
    </bit-form-field>
    <bit-form-field disableMargin>
      <bit-label>{{ "company" | i18n }}</bit-label>
      <input bitInput formControlName="company" />
    </bit-form-field>
  </div>

  <div class="bv-vault-item-form-row bv-vault-item-form-row--3">
    <bit-form-field disableMargin>
      <bit-label>{{ "ssn" | i18n }}</bit-label>
      <input formControlName="ssn" bitInput type="password" />
      <button
        type="button"
        bitIconButton
        bitSuffix
        bitPasswordInputToggle
        data-testid="visibility-for-ssn"
      ></button>
    </bit-form-field>
    <bit-form-field disableMargin>
      <bit-label>{{ "passportNumber" | i18n }}</bit-label>
      <input formControlName="passportNumber" bitInput type="password" />
      <button
        type="button"
        bitIconButton
        bitSuffix
        bitPasswordInputToggle
        data-testid="visibility-for-passport-number"
      ></button>
    </bit-form-field>
    <bit-form-field disableMargin>
      <bit-label>{{ "licenseNumber" | i18n }}</bit-label>
      <input bitInput formControlName="licenseNumber" />
    </bit-form-field>
  </div>

  <div class="bv-vault-item-form-row">
    <bit-form-field disableMargin>
      <bit-label>{{ "email" | i18n }}</bit-label>
      <input bitInput formControlName="email" />
    </bit-form-field>
    <bit-form-field disableMargin>
      <bit-label>{{ "phone" | i18n }}</bit-label>
      <input bitInput formControlName="phone" />
    </bit-form-field>
  </div>

  <div class="bv-vault-identity-details__address">
    <div class="bv-vault-item-form-row">
      <bit-form-field disableMargin>
        <bit-label>{{ "address1" | i18n }}</bit-label>
        <input bitInput formControlName="address1" />
      </bit-form-field>
      <bit-form-field disableMargin>
        <bit-label>{{ "address2" | i18n }}</bit-label>
        <input bitInput formControlName="address2" />
      </bit-form-field>
    </div>

    <div class="bv-vault-item-form-row">
      <bit-form-field disableMargin>
        <bit-label>{{ "address3" | i18n }}</bit-label>
        <input bitInput formControlName="address3" />
      </bit-form-field>
      <bit-form-field disableMargin>
        <bit-label>{{ "cityTown" | i18n }}</bit-label>
        <input bitInput formControlName="city" />
      </bit-form-field>
    </div>

    <div class="bv-vault-item-form-row">
      <bit-form-field disableMargin>
        <bit-label>{{ "stateProvince" | i18n }}</bit-label>
        <input bitInput formControlName="state" />
      </bit-form-field>
      <bit-form-field disableMargin>
        <bit-label>{{ "zipPostalCodeLabel" | i18n }}</bit-label>
        <input bitInput formControlName="postalCode" />
      </bit-form-field>
    </div>

    <bit-form-field disableMargin>
      <bit-label>{{ "country" | i18n }}</bit-label>
      <input bitInput formControlName="country" />
    </bit-form-field>
  </div>
</form>
